import React from 'react';
import { FlameIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type UrgencyBlockProps = {
  tone?: 'light' | 'dark';
  spotsTaken?: number;
};
function TimeCell({
  value,
  label,
  tone
}: {
  value: string;
  label: string;
  tone: 'light' | 'dark';
}) {
  return <div className="flex flex-col items-center" data-id="element-257" data-mp="39ybdrpb2vgon">
      <span className={`min-w-[54px] rounded-xl px-2.5 py-2 text-center font-display text-[26px] font-black tabular-nums leading-none ${tone === 'dark' ? 'bg-white/10 text-amber' : 'bg-night text-amber'}`} data-id="element-258" data-mp="39xjiygpb1mzf">
        {value}
      </span>
      <span className={`mt-1.5 text-[10px] font-bold uppercase tracking-[0.14em] ${tone === 'dark' ? 'text-canvas/60' : 'text-muted'}`} data-id="element-259" data-mp="2v095x2x0k91l">
        {label}
      </span>
    </div>;
}
export function UrgencyBlock({
  tone = 'light',
  spotsTaken = 87
}: UrgencyBlockProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className={`rounded-2xl border p-5 ${tone === 'dark' ? 'border-white/10 bg-white/[0.06]' : 'border-line bg-paper shadow-card'}`} data-id="element-260" data-mp="p8vncvfrttzj">
      <p className={`flex items-center justify-center gap-2 text-center text-[12px] font-extrabold uppercase tracking-[0.14em] ${tone === 'dark' ? 'text-canvas/80' : 'text-flame-dark'}`} data-id="element-261" data-mp="14zzyo1vre1z0">
        <FlameIcon className="h-4 w-4 text-flame" aria-hidden="true" data-id="element-262" data-mp="vz1t3f5o9meb" />
        Precio de lanzamiento — cierra en:
      </p>

      <div className="mt-3.5 flex items-start justify-center gap-2.5" role="timer" aria-live="off" data-id="element-263" data-mp="1noetl0976053">
        <TimeCell value={hours} label="Horas" tone={tone} data-id="element-264" data-mp="1smyeqyfyv7we" />
        <span className="pt-1.5 font-display text-[24px] font-black text-flame" data-id="element-265" data-mp="1smg8d8zlbdar">:</span>
        <TimeCell value={minutes} label="Min" tone={tone} data-id="element-266" data-mp="1evbg4ryjxnag" />
        <span className="pt-1.5 font-display text-[24px] font-black text-flame" data-id="element-267" data-mp="1iwwnxyw8bbds">:</span>
        <TimeCell value={seconds} label="Seg" tone={tone} data-id="element-268" data-mp="26n96s4t0isj5" />
      </div>

      <div className="mt-5" data-id="element-269" data-mp="26kwjdc4hjpyp">
        <div className="mb-1.5 flex items-baseline justify-between" data-id="element-270" data-mp="2be93pa24taln">
          <span className={`text-[11.5px] font-bold ${tone === 'dark' ? 'text-canvas/70' : 'text-muted'}`} data-id="element-271" data-mp="2bfk7h9vkuicr">
            Cupos de lanzamiento
          </span>
          <span className="text-[11.5px] font-extrabold text-flame" data-id="element-272" data-mp="2h9fmmzviz5yf">{spotsTaken}% ya tomados</span>
        </div>
        <div className={`h-2.5 w-full overflow-hidden rounded-full ${tone === 'dark' ? 'bg-white/10' : 'bg-line'}`} role="progressbar" aria-valuenow={spotsTaken} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos de lanzamiento tomados" data-id="element-273" data-mp="2c7ggji8ehuxs">
          <div className="h-full rounded-full bg-flame" style={{
          width: `${spotsTaken}%`
        }} data-id="element-274" data-mp="1xk547e4ea6wm" />
        </div>
      </div>
    </div>;
}